// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stationKey: __t.string().primaryKey().name("station_key"),
  systemId: __t.string().name("system_id"),
  name: __t.string(),
  postIndex: __t.u8().name("post_index"),
  channelsLit: __t.u8().name("channels_lit"),
  channelsMax: __t.u8().name("channels_max"),
  channelAt: __t.timestamp().name("channel_at"),
  lastGrantHour: __t.u64().name("last_grant_hour"),
  relaysReceived: __t.u32().name("relays_received"),
  grantedTotal: __t.i64().name("granted_total"),
  fundedTotal: __t.i64().name("funded_total"),
  paidTotal: __t.i64().name("paid_total"),
  status: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
